const SimulationEvent = require("./SimulationEvent");
const {convertNumIntoRoom} = require("./helper/dailyCleaning");
const regularCleaningCost = require("../../db/regularCleaning.json");

class RegularCleaning extends SimulationEvent {
  constructor(elements, emit, events) {
    super();
    this.elements = elements;
    this.emit = emit;
    this.events = events;
    this.inputs = {
      number: 0,
      numberPerRoom: 0,
      room: "",
      option: false
    }
    this.totalCost = 0;
    this.init();
  }

  // 値（インプット）の変化の監視
  init() {

    super.triggerAll(this.elements);

    // 定員数の値が変化した時
    super.watch(this.elements.capacityEle, (e) => {
      if (this.inputs.numberPerRoom) {
        this.inputs = {
          ...this.inputs,
          number: parseInt(e.target.value),
          room: convertNumIntoRoom(e.target.value, this.inputs.numberPerRoom)
        }
      } else {
        this.inputs = {
          ...this.inputs,
          number: parseInt(e.target.value)
        }
      }
      if (this.inputs.room && this.inputs.option) {
        this.calcTotalCost();
      }
    })

    // 一部屋あたりの定員人数の値が変化した時
    super.watch(this.elements.numberPerRoomEle, (e) => {
      if (this.inputs.number) {
        this.inputs = {
          ...this.inputs,
          numberPerRoom: parseInt(e.target.value),
          room: convertNumIntoRoom(this.inputs.number, parseInt(e.target.value))
        }
      } else {
        this.inputs = {
          ...this.inputs,
          numberPerRoom: parseInt(e.target.value)
        }
      }

      if (this.inputs.room && this.inputs.option) {
        this.calcTotalCost();
      }
    })


    // 委託内容が変化した時
    const checkboxes = this.elements.optionsEle.querySelectorAll(".checkbox")
    for (const checkbox of checkboxes) {
      super.watch(checkbox, (e) => {
        if (e.target.value === "regular-cleaning") {
          this.inputs = {
            ...this.inputs,
            option: e.target.checked
          }

          if (!e.target.checked) return this.resetTotalCost();

          if (this.inputs.room && this.inputs.option) {
            this.calcTotalCost();
          }
        }
      })
    }
  }

  setInputs({capacityEle, numberPerRoomEle, optionsEle}) {

    const option = optionsEle.indexOf("regular-cleaning") >= 0;
    this.inputs = {
      numberPerRoom: parseInt(numberPerRoomEle),
      number: parseInt(capacityEle),
      room: convertNumIntoRoom(capacityEle, parseInt(numberPerRoomEle)),
      option
    }


    if (this.inputs.room && this.inputs.option) {
      this.calcTotalCost();
    }
  }


  calcTotalCost() {

    const {monthly} = regularCleaningCost.data[this.inputs.room];


    this.totalCost = monthly;

    this.emit("regularCleaning", this.totalCost);
  }

  resetTotalCost() {
    this.totalCost = 0;
    this.emit("regularCleaning", this.totalCost);
  }

  getTotalCost() {
    if (!this.totalCost) return 0;
    return this.totalCost;
  }

}

module.exports = RegularCleaning;
